import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_EXERCISE_KEY } from '_api/queries/exercise/useGetAllExercise';
import { GET_ALL_PATIENT_EXERCISES_BY_ID_KEY } from '_api/queries/exercise/useGetAllPatientExercisesByID';

const DELETE_EXERCISE_SETTING_BY_ID_KEY = 'delete-exercise-setting-by-id';

export const useDeleteExerciseSettingById = () => {
  const queryClient = useQueryClient();

  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/exercise/patient-exercise-setting/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_EXERCISE_SETTING_BY_ID_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_EXERCISE_KEY] });
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_EXERCISES_BY_ID_KEY],
        });
      },
    },
  );
};
